<template>
  <Admin v-if="!isLoggedIn || (isLoggedIn && getTempPage())" />

  <div v-else class="flex relative justify-center items-center">
    <Spinner v-if="$fetchState.pending" class="abs-center" />
    <template v-else-if="pages.length">
      <div class="w-full md:w-3/5 lg:w-1/2 xl:lg:w-2/5 max-w-2xl">
        <div class="flex justify-between items-center pb-4 mb-4">
          <h2 class="mx-2 w-full text-xl">Your pages</h2>
          <CreatePageButton class="mx-auto text-base" />
        </div>

        <PageSelector :data="pages" />
      </div>
    </template>

    <CreatePageButton v-else class="mx-auto text-lg" />
  </div>
</template>

<script>
import { get, commit, dispatch } from 'vuex-pathify'

export default {
  components: {
    CreatePageButton: () => import('@/components/CreatePageButton'),
    Admin: () => import('@/components/Admin'),
    PageSelector: () => import('@/components/PageSelector'),
  },

  layout({ store }) {
    return store.state.isPublicPage ? 'public' : 'admin'
  },

  fetch() {
    if (this.page.id) {
      commit('page/RESET')
    }

    if (!this.getTempPage()) {
      dispatch('page/getDefault')
    }
  },

  fetchOnServer: false,

  computed: {
    user: get('user/data'),
    page: get('page/obj'),
    isLoggedIn: get('auth/isLoggedIn'),

    pages() {
      return this.user?.pages ?? []
    },
  },

  watch: {
    user(val, oldVal) {
      if (val.id && !oldVal.id) {
        this.showCreatePagePrompt()
      }
    },
  },

  mounted() {
    if (this.user.id) {
      this.showCreatePagePrompt()
    }
  },

  methods: {
    getTempPage() {
      return localStorage.getItem('vuex')
    },

    showCreatePagePrompt() {
      if (!this.getTempPage()) {
        return
      }

      // Set page data even if user is logged in
      // so that the user sees it in the background, behind the create page modal
      const {
        page: {
          obj: { data },
        },
      } = JSON.parse(this.getTempPage())

      if (!data.items.length) {
        localStorage.removeItem('vuex')
        return
      }

      if (data) {
        commit('page/SET_OBJ_DATA', { value: data })
      }

      this.initCreatePage()
    },

    initCreatePage() {
      this.$modal.show(
        () => import('@/components/CreatePage'),
        {
          headline: 'Save page',
          saveStoredPageMode: true,
        },
        {
          delay: 100,
          clickToClose: false,
          adaptive: true,
          scrollable: true,
          height: 'auto',
        },
        {
          'before-open'() {
            commit('INCREASE_NUM_OPEN_MODALS')
          },
          'before-close'() {
            commit('DECREASE_NUM_OPEN_MODALS')
          },
        }
      )
    },
  },
}
</script>
